import { Button } from "@/components/ui/button";
import { ArrowUpToLineIcon } from "lucide-react";
import { useEffect, useState } from "react";

export function GotoTopButton() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > window.innerHeight);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!showButton) {
    return null;
  }

  return (
    <Button
      type="button"
      intent="solid"
      size="icon"
      onClick={scrollToTop}
      className="size-12 [&_svg]:size-6 fixed bottom-12 right-12 rounded-full bg-gray-app-bg text-gray-fg-primary dark:bg-gray-fg-primary dark:text-gray-app-bg"
    >
      <ArrowUpToLineIcon />
    </Button>
  );
}
